import React from 'react'
import NavbarAdmin from '../../components/NavbarAdmin';
import DashboardChart from '../../components/DashboardChart';

function Dashboard() {

  return (
    <>
    <NavbarAdmin />
    <div style={{marginLeft:"2rem",marginRight:"2rem"}}>
      <h1>Dashboard</h1>
      <DashboardChart />
    </div>
    </>
    
 
  )
}

export default Dashboard